// This is a request. File location /src/store/requests/songs.js
import { URL_SONGS } from "../../utilities/constants";

export const fetchSongs = async (searchQuery, langs = null) => {

    const cacheDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    // Only use cache for the default first load (no language specified)
    // Language-filtered requests always fetch fresh from the API
    const useCache = !langs;
    const cacheKey = `cachedSongs_default`;
    
    if (useCache) {
        const cachedDataString = localStorage.getItem(cacheKey);
        if (cachedDataString) {
            const cachedData = JSON.parse(cachedDataString);
            const currentTime = new Date().getTime();
            if (currentTime - cachedData.timestamp < cacheDuration) {
                console.log('Using cached data');
                return cachedData.data;
            } else {
                localStorage.removeItem(cacheKey);
            }
        }
    }

    const url = URL_SONGS;
    const langHeader = langs ? (Array.isArray(langs) ? langs.join(', ') : langs) : null;
    console.log('fetch songs api', url, 'langs:', langHeader)
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(langHeader ? { 'Language': langHeader } : {}),
            },
        })

        if (!response.ok) {
            console.log('!ok response,', response)
            const errorResponse = await response.json();
            console.log('ERROR THROW: ', errorResponse.message);
            throw new Error(errorResponse.message)
        }
    
        const resData = await response.json();
        console.log('songs response', resData)

        const data = {
            songs: resData.data?.songs ?? [],
            available_langs: resData.data?.available_langs ?? [],
            default_lang: resData.data?.default_lang ?? null,
        };

        if (useCache) {
            const timestamp = new Date().getTime();
            localStorage.setItem(cacheKey, JSON.stringify({ data, timestamp }));
        }
    
        return data;
    } catch(err) {
        console.log('fetch songs res catch:', err);
        throw new Error(err.message)
    }
}